<div class="chart-with-legend" [class.is-export-report]="isExportReport">
  <div class="chart-wrapper" [class.is-export-report]="isExportReport">
      <kendo-chart #chart [title]="chartOptions.title"
          [style.width]="getChartWidth()"
          [style.height]="getChartHeight(chartAnotherArra, chartOptions.series)"
          [panes]="[{ clip: false }]"
          [zoomable]="false"
          [valueAxis]="chartOptions.valueAxis"
          [categoryAxis]="chartOptions.categoryAxis"
          [legend]="chartOptions.legend"
          [height]="isExportReport ? null : 30000"
          [seriesDefaults]="chartOptions.seriesDefaults"
          [axisDefaults]="chartOptions.axisDefaults"
          *ngIf="!noDataFound"
          [class.adjust-chart-height]="isAdjustableHeight"
          [class.is-mobile]='!isDesktop'
          [transitions]="false">
          <kendo-chart-tooltip [shared]="true" *ngIf="!router.url.includes('/observe/observeObservationProtocol')">
              <ng-template kendoChartSharedTooltipTemplate let-category="category" let-points="points">
                  <!--  <div>{{fullText[points[0].categoryIndex]}}</div> -->
                  <div>{{findTooltipText(category, points) | translate | labelSanitizer}}</div>
                  <div *ngFor="let point of points">
                      {{ point.series.name }} : {{ point.value }} {{toolTipSuffix}}
                  </div>
              </ng-template>
          </kendo-chart-tooltip>
          <kendo-chart-tooltip [shared]="true" *ngIf="router.url.includes('/observe/observeObservationProtocol')">
              <ng-template kendoChartSharedTooltipTemplate let-category="category" let-points="points">
                  <!--  <div>{{fullText[points[0].categoryIndex]}}</div> -->
                  <div>{{'DASHBOARD.NUM_COMPLIANTS' | translate}}</div>

                  {{points[1]?.value || ''}}

              </ng-template>
          </kendo-chart-tooltip>
          <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="chartAnotherArra" [maxDivisions]='maxDivisions'>
                  <kendo-chart-category-axis-item-labels [font]='font' [style]="isExportReport ? '' : 'font-size: 20em'"
                      [rotation]='chartOptions.categoryAxis.rotation'>
                  </kendo-chart-category-axis-item-labels>
              </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>
          <kendo-chart-series>
              <kendo-chart-series-item #series [type]="(type) ? type:series.type"
                  *ngFor="let series of chartOptions.series"
                  [height]="series.height"
                  [data]="series.data"
                  [labels]="( type || series.type != 'line') ? (showPercentageLabel ? getLabelPosition : getLabelPositionNoPercent) :''"
                  [name]="series.name" [color]="series.color"
                  [gap]="isExportReport ? 4 : 2"
                  [spacing]="isExportReport ? 0.2 : 0.1"
                  [overlay]="false">
              </kendo-chart-series-item>
          </kendo-chart-series>
      </kendo-chart>
  </div>

  <div #legend class="row p-4" *ngIf="!hideLegend && !noDataFound" [class.is-export-report]="isExportReport">
      <div class="legend-container" (click)="toggleSerie(serie, index)"
          [class.legend-item-inactive]="!isLegendItemActive(index)"
          *ngFor="let serie of chartOptions.series; let index = index">
          <div class="legend-item">
              <div class="legend-color mr-2" [style.background-color]="getColorImage(serie.color)"
                  [style.background-image]="getBackgroundImage(serie.color)"></div>
              <div class="legend-text">{{serie.name}}</div>
          </div>
      </div>
  </div>
</div>

<!-- <div (window:resize)="onResize($event)" (scroll)="scrollHandler($event)"></div> -->
<div (window:resize)="onResize($event)"></div>
